import { MutationRule } from '@feedyou/schema'
import { AnyObject, Mutable } from '@feedyou/utils'
import { MutationItem } from './types'

export function mutateItem(item: MutationItem) {
  // allow to specify mutations for export on-the-fly using console of opened designer
  //@ts-ignore //desc: Property 'exportMutations' does not exist on type 'Window & typeof globalThis'.
  const exportMutations: { [k: string]: string } | undefined = window.exportMutations
  if (exportMutations) {
    return mutate(item, exportMutations)
  }

  return item
}

// TODO merge with tree.ts to schema
export function mutate(object: MutationItem, userData: { [k: string]: string }) {
  const changes: { [k: string]: string | undefined } = {}
  ;(object.mutations || []).filter(testMutation(userData)).forEach((mutation: MutationRule) => {
    mutation?.set?.forEach(set => {
      if (!set.field) {
        return
      }

      changes[set.field] = set.value
    })
  })

  return { ...object, ...changes }
}

function testMutation(userData: { [k: string]: string }) {
  return (mutation: MutationRule) =>
    mutation?.test?.every(test => test.field && userData[test.field] === test.value)
}

export const getAllPossibleValuesForSpecifiedPropertiesInMutableObject = <
  O extends Mutable<AnyObject>
>(
  object: O,
  properties: Array<keyof O & string>
) => {
  const mutations = object.mutations || []

  return [
    ...properties.map(property => object[property]),
    ...mutations.flatMap(mutation => {
      return mutation?.set
        ?.filter(set => properties.includes(set.field)) // I <3 PRETTIER
        .flatMap(set => set?.value)
    })
  ]
}
